import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../i18n';
import { Sliders, Close } from '../Icons'
import StartDateInput from './StartDateInput';
import EndDateInput from './EndDateInput';
import KeywordsInput from './KeywordsInput';
import RegionsInput from './RegionsInput';
import CategoriesInput from './CategoriesInput';
import EvenTypeButton from './EvenTypeButton';
import { useToggle } from '../../helpers';

const HeaderMedium = (props) => {
    const { t } = useTranslation();
    const {
        getImageFromStorage,
        eventsCount,
        handleFilters,
        locale,
        categoriesOption,
        regionsOption,
        eventsTypeArr,
        isDesktop
    } = props

    const [keywords, setKeywords] = useState('');
    const [categories, setCategories] = useState('');
    const [regionsValue, setRegions] = useState('');
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [showFilters, toggleIsOn] = useToggle();

    const handleChangeOnKeywords = (event) => {
        const value = event.target.value;

        handleFilters('keywords', value);
        setKeywords(value);
    };

    const handleChangeOnCategories = (value) => {
        handleFilters('categories', value);
        setCategories(value);
    };

    const handleChangeOnRegions = (value) => {
        handleFilters('regions', value);
        setRegions(value);
    };

    const resetFiltersInputs = () => {
        setKeywords('');
        setCategories('');
        setRegions('');
        setStartDate('');
        setEndDate('');
    }

    return (
        (!showFilters ?
            <header className="header-bloc helvetica flex px-2 pb-3 pt-4 relative " style={{ backgroundColor: props.data.settings.header_color || props.data.settings.organization_header_color || '#fff' }}>
                <div className="header-logo-medium">
                    {
                        props.data.settings.header_logo_file_name ?
                            <img src={(getImageFromStorage())} className="header-logo" alt="header-logo" />
                            : null
                    }
                </div>
                <div className="w-full justify-center self-center">
                    <div className="w-5/6 px-4 header-btn-medium">
                        <div className="flex flex-wrap -mx-3 mt-3 justify-center relative">
                            {eventsTypeArr.map((type) => {
                                return <EvenTypeButton
                                    handleFilters={handleFilters}
                                    filters={props.filters}
                                    settings={props.data.settings}
                                    data={props.data}
                                    typeEvent={type}
                                    eventsCount={eventsCount}
                                />
                            })}
                        </div>
                    </div>
                </div>
                <div
                    className="cursor-pointer absolute top-1 right-1"
                    onClick={toggleIsOn}>
                    <span className="">
                        <Sliders width="20px" height="20px" color={props.data.settings.items_color || props.data.settings.organization_items_color || '#FF585D'} />
                    </span>
                </div>
            </header> :
            <header className="helvetica flex px-2 pb-3 pt-8 relative" style={{ backgroundColor: props.data.settings.header_color || props.data.settings.organization_header_color || '#fff' }}>
                <StartDateInput
                    handleFilters={handleFilters}
                    locale={locale}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    isDesktop={isDesktop}
                />
                <EndDateInput
                    handleFilters={handleFilters}
                    locale={locale}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    isDesktop={isDesktop}
                />
                <KeywordsInput
                    handleFilters={handleFilters}
                    locale={locale}
                    keywords={keywords}
                    handleChangeOnKeywords={handleChangeOnKeywords}
                    isDesktop={isDesktop}
                />
                <CategoriesInput
                    handleFilters={handleFilters}
                    locale={locale}
                    categories={categories}
                    categoriesOption={categoriesOption}
                    handleChangeOnCategories={handleChangeOnCategories}
                    isDesktop={isDesktop}
                />
                <RegionsInput
                    handleFilters={handleFilters}
                    locale={locale}
                    regionsValue={regionsValue}
                    regionsOption={regionsOption}
                    handleChangeOnRegions={handleChangeOnRegions}
                    isDesktop={isDesktop}
                />
                <div
                    className="text-ed-grey underline text-sm cursor-pointer self-end px-3"
                    onClick={() => { handleFilters('type', 'reset_filters'); resetFiltersInputs() }}>
                    {t('reset_filters')}
                </div>
                <div
                    className="absolute top-1 right-1 cursor-pointer"
                    onClick={toggleIsOn}>
                    <span className="mr-2 pt-0.5">
                        <Close width="25px" height="25px" color={props.data.settings.items_color || props.data.settings.organization_items_color || '#FF585D'} />
                    </span>
                </div>
            </header>
        )

    )
}
export default HeaderMedium;